import React from 'react'

import { Box, Tabs } from '@factorialco/deprecated-design-system'

import type { WithMultiSelectStateChildrenProps } from 'modules/core/components/WithMultiSelectState'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { ProjectsToImport } from 'modules/project_management/lib/types'

import ImportsTable from './_Table'
import { LegalEntity } from './_Table/_Body/CellContent'

type WithMultiSelectProps = WithMultiSelectStateChildrenProps<ProjectsToImport>

interface ImportProjectsTableProps {
  onToggleSelectedItem: WithMultiSelectProps['onToggleSelectedItem']
  onDeselectAll: () => void
  onSelectAll: () => void
  projectsReady: ProjectsToImport[]
  projectsErrored: ProjectsToImport[]
  selected: ProjectsToImport[]
  legalEntities: LegalEntity[]
  defaultCurrency: string
}

const TABS = {
  ready: 'ready',
  errored: 'errored',
}

const ImportProjectsTable = ({
  onToggleSelectedItem,
  onDeselectAll,
  onSelectAll,
  projectsErrored,
  projectsReady,
  selected,
  legalEntities,
  defaultCurrency,
}: ImportProjectsTableProps) => {
  const [tabs, setTabs] = React.useState([
    {
      id: TABS.ready,
      active: true,
      label: i18n.t('project_management.imports.table.tabs.ready_to_import'),
      numberOfProjects: projectsReady.length.toString(),
    },
    {
      id: TABS.errored,
      active: false,
      label: i18n.t('project_management.imports.table.tabs.errors'),
      numberOfProjects: projectsErrored.length.toString(),
    },
  ])

  return (
    <Tabs
      currentId={tabs.find((tab) => tab.active)?.id ?? ''}
      onTabClicked={(tabId) => {
        if (tabId === TABS.errored) {
          track(trackingEvents.projectManagement.importProjects.visitImportProjectsErrorsTab)
        }
        setTabs(
          tabs.map((tab) => {
            if (tab.id === tabId) {
              return {
                ...tab,
                active: true,
              }
            }
            return {
              ...tab,
              active: false,
            }
          })
        )
      }}
    >
      {tabs.map(({ id, label, numberOfProjects }) => (
        <Tabs.Tab
          key={id}
          id={id}
          label={label}
          tag={numberOfProjects}
          showNotification={!!projectsErrored.length && id === TABS.errored}
        >
          <Box paddingTop="s32">
            {id === TABS.ready && (
              <ImportsTable
                onToggleSelectedItem={onToggleSelectedItem}
                onSelectAll={onSelectAll}
                onDeselectAll={onDeselectAll}
                projectsList={projectsReady}
                selected={selected}
                tabId={id}
                legalEntities={legalEntities}
                defaultCurrency={defaultCurrency}
              />
            )}
            {id === TABS.errored && (
              <ImportsTable
                onToggleSelectedItem={onToggleSelectedItem}
                onSelectAll={onSelectAll}
                onDeselectAll={onDeselectAll}
                selected={selected}
                projectsList={projectsErrored}
                tabId={id}
                legalEntities={legalEntities}
                defaultCurrency={defaultCurrency}
              />
            )}
          </Box>
        </Tabs.Tab>
      ))}
    </Tabs>
  )
}

export default ImportProjectsTable
